export const Localities = [
  {
    id: 0,
    name: 'Mauritius',
    value: 'Local'
  },
  {
    id: 1,
    name: 'International',
    value: 'International'
  },
  {
    id: 2,
    name: 'Combined',
    value: ''
  }
]



// WEBPACK FOOTER //
// ./src/app/common/enums/Locality.ts